import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let is_included_in_insurance_claim = useDataValue({
    context: 'charge',
    path: 'is_included_in_insurance_claim',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!data) return data

    return data.filter(
      item => item.id !== 'MOVE_TO_CLAIM' || is_included_in_insurance_claim
    )
  }, [data, is_included_in_insurance_claim])
}
